export default "__VITE_ASSET__b8776498__"